import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import BgImg from "../../assets/portfolio/bg2.png";
// import BgImg from "../../assets/images/bg5.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TechnicalImage from "../../assets/service/technical-maintenance.png";
import TechnicalHero from "../../assets/service/technical-maintenance-hero.png";
import OurClients from "../OurClients/OurClients";

import {
  faCloud,
  faLock,
  faRocket,
  faDollarSign,
} from "@fortawesome/free-solid-svg-icons";
import TechnicalFaq from "../ServiceImp/TechnicalFaq";
import { Helmet } from "react-helmet-async";

function TechnicalMaintenance() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with animation duration and animation trigger once
  }, []);

  const pillars = [
    {
      icon: faCloud, // Cloud icon for Cloud Migration
      title: "Scalability",
      description:
        "Move to a scalable infrastructure that grows with your business needs, enabling better performance and flexibility.",
      bgColor: "bg-blue-100",
    },
    {
      icon: faDollarSign, // Dollar icon for Cost Savings
      title: "Cost Reduction",
      description:
        "Reduce infrastructure and maintenance costs by leveraging cloud environments and automated services.",
      bgColor: "bg-green-100",
    },
    {
      icon: faLock, // Lock icon for Security
      title: "Improved Security",
      description:
        "Enhance the security of your applications with better encryption, compliance, and vulnerability protection.",
      bgColor: "bg-orange-100",
    },
    {
      icon: faRocket, // Rocket icon for Speed and Performance
      title: "Enhanced Performance",
      description:
        "Optimize your applications with modern technologies to improve speed, responsiveness, and user experience.",
      bgColor: "bg-purple-100",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Technical Maintenance Services | Deetyasoft</title>
        <meta
          name="description"
          content="Ensure smooth IT operations with Deetya Soft’s technical maintenance services. Get expert support, regular upkeep, and system optimization."
        />
        <meta
          name="keywords"
          content="technical maintenance services, IT support services, system maintenance solutions, server maintenance, Deetya Soft maintenance, website maintenance, software support, hardware and network maintenance, IT infrastructure upkeep, technical troubleshooting services, preventive IT maintenance"
        />
        <link
          rel="canonical"
          href="https://deetyasoft.com/technical-maintenance-services"
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/technical-maintenance-services"
        />
        <meta
          property="og:title"
          content="Technical Maintenance Services | Deetyasoft"
        />
        <meta
          property="og:description"
          content="Ensure smooth IT operations with Deetya Soft’s technical maintenance services. Get expert support, regular upkeep, and system optimization."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/technical-maintenance.8984c2d1e46b823fe5a1.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/technical-maintenance-services"
        />
        <meta
          name="twitter:title"
          content="Technical Maintenance Services | Deetyasoft"
        />
        <meta
          name="twitter:description"
          content="Ensure smooth IT operations with Deetya Soft’s technical maintenance services. Get expert support, regular upkeep, and system optimization."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/technical-maintenance.8984c2d1e46b823fe5a1.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}
        <>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Organization",
                name: "Deetya Soft Pvt Ltd",
                description:
                  "Ensure smooth IT operations with Deetya Soft’s technical maintenance services. Get expert support, regular upkeep, and system optimization.",
                image:
                  "https://deetyasoft.com/static/media/technical-maintenance.8984c2d1e46b823fe5a1.png",
                logo: "https://www.deetyasoft.com/images/logo.png",
                url: "https://www.deetyasoft.com",
                telephone: ["+91-9015350505", "+91-9717055088"],
                email: "info@deetyasoft.com",
                sameAs: [
                  "https://www.linkedin.com/company/deetya-soft-private-limited",
                  "https://www.facebook.com/deetyasoftprivatelimited",
                  "https://www.instagram.com/deetyasoft",
                  "https://www.youtube.com/@deetyasoft",
                  "https://www.crunchbase.com/organization/deetyasoft",
                ],
                address: {
                  "@type": "PostalAddress",
                  streetAddress:
                    "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
                  addressLocality: "Ghaziabad",
                  addressRegion: "Uttar Pradesh",
                  postalCode: "201014",
                  addressCountry: "IN",
                },
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Organization",
                url: "https://www.deetyasoft.com",
                contactPoint: [
                  {
                    "@type": "ContactPoint",
                    telephone: "+91-981-862-7588",
                    contactType: "technical support",
                    areaServed: "IN",
                  },
                  {
                    "@type": "ContactPoint",
                    telephone: "+91-901-535-0505",
                    contactType: "sales",
                    areaServed: "IN",
                  },
                ],
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Review",
                author: {
                  "@type": "Person",
                  name: "Parshan ",
                },
                reviewBody:
                  "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
                url: "https://www.deetyasoft.com/",
                description:
                  "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
                datePublished: "2025-06-17",
                name: "Deetya Soft Pvt Ltd",
                reviewRating: {
                  "@type": "Rating",
                  worstRating: "1",
                  ratingValue: "5",
                  bestRating: "5",
                },
                itemReviewed: {
                  "@type": "Organization",
                  name: "Deetya Soft Pvt Ltd",
                },
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name: "What is Technical Maintenance?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Technical Maintenance involves the regular upkeep of software applications, servers, and network infrastructure to ensure optimal performance, security, and reliability.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Why is Technical Maintenance important?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "It prevents unexpected downtime, addresses vulnerabilities, improves application performance, and ensures compatibility with the latest technologies.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What are the key activities included in Technical Maintenance?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Key activities include software updates, security patches, performance optimization, data backups, and regular monitoring of systems and networks.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "How often should Technical Maintenance be performed?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "The frequency depends on the application and business needs, but regular maintenance schedules—monthly, quarterly, or annually—are recommended for optimal performance.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Can Technical Maintenance be automated?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, many maintenance tasks such as backups, updates, and monitoring can be automated to reduce manual effort and minimize human error.",
                    },
                  },
                ],
              }),
            }}
          />
        </>
      </Helmet>
      {/* heroo section */}

      <div className="relative bg-[#2f68a2] overflow-hidden pb-5 text-white">
        {/* Content */}
        <div className="relative z-20 max-w-7xl mx-auto  px-6 py-10 grid md:grid-cols-2 lg:gap-20 md:gap-10  items-start">
          {/* Left Side */}
          <div>
            <h1 className="text-3xl md:text-4xl font-bold leading-snug mb-4">
              Technical Maintenance
            </h1>
            <p className="text-white/90 mb-6 text:base md:text-lg">
              Technical Maintenance is the ongoing process of keeping software,
              IT systems, and applications secure, efficient, and up-to-date
              through regular updates, bug fixes, and performance optimizations.
            </p>
            <button
              className="bg-orange-500   hidden md:block hover:bg-orange-600 text-white px-5 py-3 rounded shadow-md transition"
              onClick={() => {
                const target = document.getElementById("bottomTarget");
                if (target) {
                  target.scrollIntoView({ behavior: "smooth", block: "start" });
                  // Optional offset tweak using window.scrollBy
                  setTimeout(() => {
                    window.scrollBy(0, -100); // scrolls 100px up after reaching the section
                  }, 600);
                }
              }}
            >
              Let's Get Started
            </button>
          </div>

          {/* Right Side Image */}
          <div className="flex justify-center">
            <img
              src={TechnicalHero}
              alt="Technical"
              className="md:w-[90%] object-contain w-full  max-w-lg animate-float"
            />
          </div>
        </div>

        {/* FIRST CURVE - White */}
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 290"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L60,165.3C120,171,240,181,360,165.3C480,149,600,107,720,117.3C840,128,960,192,1080,208C1200,224,1320,192,1380,176L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>

        {/* SECOND CURVE - Light Blue */}
        <div className="absolute bottom-[20px] left-0 w-full z-0">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path
              fill="#a6c7e2" // Light blue like in the image
              fillOpacity="1"
              d="M0,288L60,272C120,256,240,224,360,197.3C480,171,600,149,720,160C840,171,960,213,1080,208C1200,203,1320,149,1380,122.7L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>
      </div>

      {/* second web solution section */}

      <div className="">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-bold text-center mt-4 mb-2 text-gray-600">
          Technical Maintenance
        </h2>
        <div className="md:w-28 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        <p className="text-center text-gray-700 px-4 md:px-20 lg:px-40">
          Ensure the smooth operation, security, and optimization of your
          software and IT systems through regular updates, performance
          enhancements, and proactive troubleshooting.
        </p>

        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Image Section */}
            <div className="w-full max-w-xl mx-auto px-4 sm:px-6 lg:px-8">
              <img
                src={TechnicalImage}
                alt="Technical Maintenance"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Text Content Section */}
            <div className="space-y-4 text-gray-700 leading-relaxed text-justify">
              <p>
                Technical Maintenance involves the continuous process of
                optimizing, securing, and updating software applications and IT
                infrastructure. This proactive approach helps prevent system
                failures, enhance performance, and improve overall reliability.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 md:text-2xl lg:text-3xl mt-4">
                Key Areas of Maintenance:
              </h3>

              <ul className="list-disc pl-5 space-y-1">
                <li>Regular Software Updates</li>
                <li>Security Patches and Vulnerability Fixes</li>
                <li>Performance Optimization</li>
                <li>Data Backup and Recovery</li>
                <li>Compatibility Adjustments</li>
              </ul>

              <p>
                At <strong>Deetya Soft</strong>, we ensure your applications and
                systems remain secure, efficient, and fully optimized with
                minimal disruptions, so your business runs smoothly.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* third section  benifits*/}

      <div
        className="py-5 px-5 relative"
        // data-aos='fade-up'
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-3xl md:text-4xl font-extrabold">
            <span className="text-black">Benifits Of </span>
            <span className="text-sky-500"> Migration</span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-400 md:w-[200px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-800 text-base mt-4">
            What You Get Using Our Inventory Management System
          </p>
        </div>

        <div className="container mx-auto px-4 pb-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {pillars.map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-8 text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                  >
                    <FontAwesomeIcon
                      icon={pillar.icon}
                      className="text-sky-500 text-2xl"
                    />
                  </div>
                  <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                    {pillar.title}
                  </h5>
                  <p className="text-gray-600 text-sm">{pillar.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* faq section technicl */}
      <TechnicalFaq />

      {/* client section */}
      <div id="bottomTarget">
        <OurClients />
      </div>
    </>
  );
}

export default TechnicalMaintenance;
